import React from "react";
import { NavbarLinks } from "./navbar.links";
import iconIG from "../../assets/icons/ig.png";
import iconStore from "../../assets/icons/shop.png";
import iconYT from "../../assets/icons/yt.png";
import iconTiktok from "../../assets/icons/tiktok.png";
import iconSteam from "../../assets/icons/steam.png";
import { Clickable } from "../clickable.container";

interface Props {
  onClick: () => void;
}

export const NavbarOverlay: React.FC<Props> = ({ onClick }) => {
  return (
    <div>
      <NavbarLinks onClick={onClick}></NavbarLinks>
      <div className="navbar-overlay-external-links">
        <Clickable
          onclick={() => {
            window.open("https://vertexhorizons.gumroad.com/", "_blank");
          }}
          children={
            <div className="navbar-overlay-external-link">
              <img
                src={iconStore}
                alt="Logo"
                className="navbar-overlay-external-link-icon"
              />
              <div
                className={
                  "title-text-font" + " " + "navbar-overlay-external-link-text"
                }
              >
                STORE
              </div>
            </div>
          }
          backgroundUrl={""}
          style=""
        />
        <Clickable
          onclick={() => {
            window.open(
              "https://store.steampowered.com/app/3623600/Evergrow_Shards_of_Tomorrow/",
              "_blank",
            );
          }}
          children={
            <div className="navbar-overlay-external-link">
              <img
                src={iconSteam}
                alt="Logo"
                className="navbar-overlay-external-link-icon"
              />
              <div
                className={
                  "title-text-font" + " " + "navbar-overlay-external-link-text"
                }
              >
                STEAM
              </div>
            </div>
          }
          backgroundUrl={""}
          style=""
        />
        <Clickable
          onclick={() => {
            window.open("https://www.youtube.com/@VertexHorizons", "_blank");
          }}
          children={
            <div className="navbar-overlay-external-link">
              <img
                src={iconYT}
                alt="Logo"
                className="navbar-overlay-external-link-icon"
              />
              <div
                className={
                  "title-text-font" + " " + "navbar-overlay-external-link-text"
                }
              >
                YOUTUBE
              </div>
            </div>
          }
          backgroundUrl={""}
          style=""
        />
        <Clickable
          onclick={() => {
            window.open("https://www.tiktok.com/@vertexhorizons", "_blank");
          }}
          children={
            <div className="navbar-overlay-external-link">
              <img
                src={iconTiktok}
                alt="Logo"
                className="navbar-overlay-external-link-icon"
              />
              <div
                className={
                  "title-text-font" + " " + "navbar-overlay-external-link-text"
                }
              >
                TIKTOK
              </div>
            </div>
          }
          backgroundUrl={""}
          style=""
        />
        <Clickable
          onclick={() => {
            window.open("https://www.instagram.com/vertexhorizons/", "_blank");
          }}
          children={
            <div className="navbar-overlay-external-link">
              <img
                src={iconIG}
                alt="Logo"
                className="navbar-overlay-external-link-icon"
              />
              <div
                className={
                  "title-text-font" + " " + "navbar-overlay-external-link-text"
                }
              >
                INSTAGRAM
              </div>
            </div>
          }
          backgroundUrl={""}
          style=""
        />
      </div>
    </div>
  );
};
